// The controls panel floats over the scene like the map's panel: down the left side of a wide
// screen, and as a sheet along the bottom of a phone. Hiding it leaves just its header, and the
// choice is remembered.

const STORAGE_KEY = "glc.3dPanelOpen";
export const SHEET_QUERY = "(max-width: 699px)";
const OPEN_BY_DEFAULT_QUERY = "(min-width: 700px) and (min-height: 501px)";

// How much of the stage the panel covers: the strip on the left while it is open beside the
// scene, or the strip along the bottom while it is a sheet (whose header bar always shows).
export function panelInsets(stageBox, panelBox, { open, sheet }) {
  if (sheet) return { left: 0, bottom: Math.max(0, Math.round(stageBox.bottom - panelBox.top)) };
  return { left: open ? Math.max(0, Math.round(panelBox.right - stageBox.left)) : 0, bottom: 0 };
}

// `insets` always holds the latest panelInsets(), and the same numbers are on `root` as the
// --panel-left and --panel-bottom custom properties, so the stage overlays can keep clear.
export function controlsPanel({ root, stage, panel, toggle, header, onToggle }) {
  const sheet = window.matchMedia(SHEET_QUERY);
  const insets = { left: 0, bottom: 0 };
  const isOpen = () => !panel.classList.contains("is-collapsed");

  function layout() {
    Object.assign(insets, panelInsets(stage.getBoundingClientRect(), panel.getBoundingClientRect(), { open: isOpen(), sheet: sheet.matches }));
    root.style.setProperty("--panel-left", `${insets.left}px`);
    root.style.setProperty("--panel-bottom", `${insets.bottom}px`);
  }

  function setOpen(open, remember = true) {
    panel.classList.toggle("is-collapsed", !open);
    root.classList.toggle("is-panel-collapsed", !open);
    toggle.setAttribute("aria-expanded", String(open));
    toggle.textContent = open ? "Hide" : "Controls";
    if (remember) {
      try { localStorage.setItem(STORAGE_KEY, open ? "1" : "0"); } catch { /* storage unavailable */ }
      onToggle?.(open);
    }
    layout();
  }

  toggle.addEventListener("click", (event) => {
    event.stopPropagation();
    setOpen(!isOpen());
  });
  // On a phone the whole header bar opens and closes the sheet, the title included.
  header.addEventListener("click", (event) => {
    if (!sheet.matches) return;
    event.preventDefault();
    setOpen(!isOpen());
  });
  sheet.addEventListener?.("change", layout);
  new ResizeObserver(layout).observe(panel);
  setOpen(savedOpen(), false);
  return { insets, layout };
}

function savedOpen() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    // Small or short screens start with the panel closed so the lakes are visible.
    return saved === null ? window.matchMedia(OPEN_BY_DEFAULT_QUERY).matches : saved === "1";
  } catch {
    return true;
  }
}
